import { render, staticRenderFns } from "./CompanySizesTable.vue?vue&type=template&id=352a47cc&"
import script from "./CompanySizesTable.vue?vue&type=script&lang=js&"
export * from "./CompanySizesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports